import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ocean text-cream/85 py-14">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 rounded-full bg-terracotta flex items-center justify-center text-cream font-serif-elegant text-lg leading-none">
              k
            </span>
            <span className="font-serif-elegant text-2xl">Kerstin Cloodt</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-cream/70 max-w-xs">
            Begleitetes Malen &amp; Freie Kunst. Ein Raum, in dem du dir selbst
            begegnen darfst.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-terracotta mb-4">
            Menü
          </div>
          <ul className="space-y-2 text-sm">
            <li><a href="/#ueber-mich" className="hover:text-terracotta transition-colors">Über mich</a></li>
            <li><a href="/#angebote" className="hover:text-terracotta transition-colors">Angebote</a></li>
            <li><a href="/#kunst" className="hover:text-terracotta transition-colors">Meine Kunst</a></li>
            <li><a href="/#kontakt" className="hover:text-terracotta transition-colors">Kontakt</a></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-terracotta mb-4">
            Kontakt &amp; Rechtliches
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <a
                href="mailto:kerstin.cloodt@googlemail.com"
                className="hover:text-terracotta transition-colors"
                data-testid="footer-email-link"
              >
                kerstin.cloodt@googlemail.com
              </a>
            </li>
            <li>
              <a
                href="tel:+4915168129874"
                className="hover:text-terracotta transition-colors"
                data-testid="footer-phone-link"
              >
                0151&nbsp;68129874
              </a>
            </li>
            <li>
              <Link
                to="/impressum"
                className="hover:text-terracotta transition-colors"
                data-testid="footer-impressum-link"
              >
                Impressum
              </Link>
            </li>
            <li>
              <Link
                to="/datenschutz"
                className="hover:text-terracotta transition-colors"
                data-testid="footer-datenschutz-link"
              >
                Datenschutz
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-10 pt-6 border-t border-cream/15 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-cream/60">
        <span>© {new Date().getFullYear()} Kerstin Cloodt. Alle Rechte vorbehalten.</span>
        <span>Gestaltet mit Empathie und Farbe.</span>
      </div>
    </footer>
  );
}
